import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import * as BetaFeaturesActions from './beta-features.actions';
import { of } from 'rxjs';

@Injectable()
export class BetaFeaturesEffects {
  loadBetaFeatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BetaFeaturesActions.loadBetaFeatures),
      switchMap(() => {
        const enabled = localStorage.getItem('show-beta-features') === 'true';
        return of(BetaFeaturesActions.setBetaFeatures({ enabled }));
      })
    )
  );

  // Effect to persist beta features state to localStorage
  persistBetaFeatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        BetaFeaturesActions.enableBetaFeatures,
        BetaFeaturesActions.disableBetaFeatures,
        BetaFeaturesActions.setBetaFeatures
      ),
      tap(action => {
        if (action.type === BetaFeaturesActions.enableBetaFeatures.type) {
          localStorage.setItem('show-beta-features', 'true');
        } else if (action.type === BetaFeaturesActions.disableBetaFeatures.type) {
          localStorage.removeItem('show-beta-features');
        } else if (action.type === BetaFeaturesActions.setBetaFeatures.type) {
          if (action.enabled) {
            localStorage.setItem('show-beta-features', 'true');
          } else {
            localStorage.removeItem('show-beta-features');
          }
        }
      })
    ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
